import keyMirror from 'keymirror';

export const achievementsActionTypes = keyMirror({
	GET_CATEGORIES_REQUEST: null,
	GET_CATEGORIES_SUCCESS: null,
	GET_CATEGORIES_ERROR: null,

	GET_ACHIEVEMENTS_REQUEST: null,
	GET_ACHIEVEMENTS_ERROR: null,
	GET_ACHIEVEMENTS_SUCCESS: null,

	SET_ACTIVE_CATEGORY_ID: null,

	RESET_ACHIEVEMENTS: null,
});
